import React from "react";

export default function GameText({ children }: { children: React.ReactNode }) {
  return <p className="text-primary-1100 dark:text-primary-100 max-w-[65ch] indent-8">{children}</p>;
}
